import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100/70">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            吃瓜问答
          </h2>
          <p className="text-sm md:text-base text-foreground-500 font-body">
            关于网红黑料网，你关心的问题都在这里
          </p>
        </div>

        <div className="flex flex-col gap-3 md:gap-4">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer bg-transparent border-0"
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <i
                  className={`text-foreground-400 shrink-0 transition-transform duration-300 text-lg ${
                    openIndex === i ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 font-body leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}